import { render, staticRenderFns } from "./order-list.vue?vue&type=template&id=2875e048&"
import script from "./order-list.vue?vue&type=script&lang=ts&"
export * from "./order-list.vue?vue&type=script&lang=ts&"
import style0 from "./order-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports